import styles from './provide-email-form.module.scss';
import { Button } from '@spotted-zebra-uk/ui-components';
import { Formik, useField } from 'formik';
import { useTranslation } from 'react-i18next';
import * as yup from 'yup';
import { useMemo } from 'react';
import { FormikTextInputField } from '@spotted-zebra-uk/ui-components';
const initialValues = { email: '' };

type ProvideEmailFormProps = {
  submitting: boolean;
  onEmailSubmit: (email: string) => void;
};

export const ProvideEmailForm = ({
  submitting,
  onEmailSubmit,
}: ProvideEmailFormProps) => {
  const { t } = useTranslation();

  const validationForm = useMemo(() => {
    return yup.object().shape({
      email: yup
        .string()
        .email(t('forms.emailIsInvalid'))
        .required(t('forms.emailIsInvalid')),
    });
  }, []);

  const onSubmit = (values: { email: string }) => {
    onEmailSubmit(values.email);
  };

  return (
    <Formik
      onSubmit={onSubmit}
      initialValues={initialValues}
      validationSchema={validationForm}
    >
      {({ handleSubmit }) => (
        <form onSubmit={e => e.preventDefault()}>
          <FormikTextInputField
            id="email"
            label={t('forms.email')}
            placeholder={t('forms.email')}
            useFormikField={useField}
          />
          <Button
            onClick={() => handleSubmit()}
            fullWidth
            className={styles.submitButton}
            disabled={submitting}
          >
            {t('common.continue')}
          </Button>
        </form>
      )}
    </Formik>
  );
};
